module.exports = {
  BUS: 'bus',
  METRO: 'metro',
  TRAIN: 'train',
  TRAM: 'tram',
};
